<template>
  <BootstrapModal
    class="CreateDiscount mt-6"
    :remove-padding="true"

    v-on="$listeners"
    @save="editDiscount"
  >
    <template #title>
      Bestelling toevoegen
    </template>

    <div class="d-flex discount-wrapper" :class="!loading && 'disable-ske'">
      <DiscountDetails class="discount-details flex-shrink-0"
        v-model="discountDetails"
        :show-title="true"
        :remove-flex="true"
      />
      <ProductFinder
        v-model="products"

        class="flex-grow-1 ProductFinder"
        :show-loading="loading"
        :remove-inputs='true'
        :show-title="true"
        :ske="true"
      />
    </div>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import SetupStepsSidebar from "../../SetupStepsSidebar/SetupStepsSidebar.vue"

import ProductFinder from "../../../components/Product/ProductFinder/ProductFinder.vue"
import DiscountDetails from "./EditOrder/DiscountDetails.vue"

import { fixCommaFloatingPointNumber } from "src/mixins/fixDecimalCommaNotation"

export default {
  components: {
    DiscountDetails,
    BootstrapModal,
    SetupStepsSidebar,
    ProductFinder,
  },
  props: {
    discount: Object,
    callback: Function,
  },
  data() {
    return {
      discountDetails: {},
      products: [],
      loading: true,
    }
  },
  created() {
    this.loadProducts()

    const item = this.discount
    if (item) {
      this.discountDetails.name = item.name
      this.discountDetails.value = item.value
      this.discountDetails.discount_value = item.value
      this.discountDetails.startDate = item.startDate
      this.discountDetails.minimum_price = item.minimum_price
      this.discountDetails.endDate = item.endDate
      this.discountDetails.type = item.type
      this.discountDetails.couponCode = item.couponCode
    }
  },
  methods: {
    async loadProducts() {
      this.loading = true

      const {products} = (await this.axios.get(`/api/discounts/${this.discount.uid}`)).data
      this.products = products

      this.loading = false
    },
    async editDiscount() {
      const details =  { ...this.discountDetails }
      details.value = fixCommaFloatingPointNumber(details.discount_value)
      delete details.discount_value

      console.log(details.value)

      this.$handlePromise(async () => {
        await this.axios.put(`/api/discounts/${this.discount.uid}`, {
          ...details,

          products: this.products.map(item => item.sku),
        })
        this.$store.dispatch('clearCacheSearch', "discounts")

        this.$success("Korting bewerkt!")
        this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.discount-details {
  flex-basis: 375px;
  border-right: 1px solid var(--black-06);
}

.CreateDiscount {
  flex-basis: 1300px;
  min-height: 600px;
}

@media (min-width: 769px) {
  .CreateDiscount {
    min-height: 800px;
  }
}

@media (max-width: 768px) {
  .discount-wrapper {
    flex-direction: column;
    overflow: auto;
  }

  .discount-details {
    border-right: none;
  }

  .ProductFinder {
    flex-shrink: 0;
    border-top: 1px solid var(--black-06);
  }
}

@media (max-width: 400px) {
  .CreateDiscount {
    min-height: 400px;
  }
}

</style>
